import { Controller } from '@hotwired/stimulus';
import tippy, {followCursor} from 'tippy.js';

export default class extends Controller {
	connect() {
		let config = {};

		if (this.element.dataset.config) {
			config = JSON.parse(this.element.dataset.config);
		}

		const defaults = {
			content: this.element.dataset.content,
			animation: 'scale',
			allowHTML: true,
			interactive: this.element.dataset.interactive || false,
			maxWidth: 450,
			followCursor: 'horizontal',
			plugins: [followCursor],
		};

		const options = {...defaults, ...config};

		if (options.content) {
			tippy(this.element, {...defaults, ...config});
		}
	}
}
